import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 获取下载地址
export const getGameLink = () =>
  http.httpGet({
    url: httpApi.homes.getGameLink,
  });

// 落地页游戏列表
export const getBdfbGameInfo = () =>
  http.httpGet({
    url: httpApi.homes.getBdfbGameInfo,
  });

// 获取QQ一键加群KEY
export const getQQKey = () =>
  http.httpGet({
    url: httpApi.homes.getQQKey,
  });

// 获取盒子下载链接
interface GetDownUrlData {
  channel_type: number;
  device: string;
  channel_code: string;
}

export const getDownUrl = (json: GetDownUrlData): any =>
  http.httpPost({
    url: httpApi.homes.getDownUrl,
    json,
  });

// 排行榜
interface HomeListData {
  token: string;
}

export const homeList = (json: HomeListData): any =>
  http.httpPost({
    url: httpApi.homes.homeList,
    json,
  });

// 排行榜java
interface AllRankGamesData {
  gameType: string;
}

export const allRankGames = (json: AllRankGamesData): any =>
  http.httpGet({
    url: httpApi.homes.allRankGames,
    json,
  });

// 新闻列表
interface GetNewsListData {
  size: number;
  page: number;
  is_seo: number;
}

export const getNewsList = (json: GetNewsListData): any =>
  http.httpPost({
    url: httpApi.homes.getNewsList,
    json,
  });

// 获取新闻详情
interface GetNewsInfoData {
  id: string;
}

export const getNewsInfo = (json: GetNewsInfoData): any =>
  http.httpPost({
    url: httpApi.homes.getNewsInfo,
    json,
  });

// 游戏详情
interface GameInfoJson {
  box_game_id: string;
}

export const gameInfo = (json: GameInfoJson): any =>
  http.httpPost({
    url: httpApi.homes.gameInfo,
    json,
  });

// 游戏详情java
interface GetGameInfoJson {
  token: string;
  gameId: string;
}
export const getGameInfo = (json: GetGameInfoJson): any =>
  http.httpGet({
    url: httpApi.homes.getGameInfo,
    json,
  });

// 同厂推荐
interface FirmRecommendJson {
  box_game_id: string;
  factory_id: string;
}
export const firmRecommend = (json: FirmRecommendJson): any =>
  http.httpPost({
    url: httpApi.homes.firmRecommend,
    json,
  });

// 新游推荐
interface NewGameListJson {
  gameType: number;
}
export const newGameList = (json: NewGameListJson): any =>
  http.httpGet({
    url: httpApi.homes.newGameList,
    json,
  });

interface ByRandData {
  token: string;
}
// 版本与标签接口
export const tagList = (json: ByRandData): any =>
  http.httpPost({
    url: httpApi.homes.tagList,
    json,
  });

// 版本与标签接口
export const getAllVersionAndTagList = (json: ByRandData): any =>
  http.httpPost({
    url: httpApi.homes.getAllVersionAndTagList,
    json,
  });

// 时间段配置获取
export const getTimeSection = (json: ByRandData): any =>
  http.httpPost({
    url: httpApi.homes.getTimeSection,
    json,
  });

// 开服列表
interface GetListShunWanData {
  bow_time: number;
  page: number;
  size: number;
  section_id: string;
  versionid: string;
  tag: string;
}
// 版本与标签接口
export const getListShunWan = (json: GetListShunWanData): any =>
  http.httpPost({
    url: httpApi.homes.getListShunWan,
    json,
  });

interface HotSearchJson {
  token: string;
}
// 游戏热搜数据
export const hotSearch = (json: HotSearchJson): any =>
  http.httpGet({
    url: httpApi.homes.hot_search,
    json,
  });

interface QueryPrefixJson {
  cueword: string;
}
// 搜索框提示词
export const queryPrefix = (json: QueryPrefixJson): any =>
  http.httpGet({
    url: httpApi.homes.query_prefix,
    json,
  });

// 搜索框随机提示词
export const getCueWord = (json: HotSearchJson) =>
  http.httpGet({
    url: httpApi.homes.getCueWord,
    json,
  });

interface EsSearchJson {
  search_info: string;
  show_icon: number;
}
// 游戏搜索页
export const esSearch = (json: EsSearchJson): any =>
  http.httpPost({
    url: httpApi.homes.es_search,
    json,
  });

// 清空历史记录
interface DelHistoryJson {
  id: object;
  uid: string;
}
export const delHistory = (json: DelHistoryJson): any =>
  http.httpPost({
    url: httpApi.homes.del_history,
    json,
  });

// 删除单挑历史记录
interface DelSingleHistoryJson {
  token: string;
  id: string;
}
export const delSingleHistory = (json: DelSingleHistoryJson): any =>
  http.httpPost({
    url: httpApi.homes.del_single_history,
    json,
  });

// 获取ios下载key
export const getIosAppKeyApi = (): any =>
  http.httpPost({
    url: httpApi.homes.getIosAppKey,
  });

// bing搜索游戏点击下载java
interface ClickBingJson {
  type: number;
  clickId: number;
  deviceId: string;
  bingType: number;
}
export const clickBing = (json: ClickBingJson): any =>
  http.httpPost({
    url: httpApi.homes.clickBing,
    json,
  });

// 获取ios下载链接
interface IosDownloadClickJson {
  url: string;
}
export const iosDownloadClick = (json: IosDownloadClickJson): any =>
  http.httpPost({
    url: httpApi.homes.iosDownloadClick,
    json,
  });

// 优酷上报第三方调用数据检测
interface MonitorJson {
  clickId: string;
  principalId: string;
  adId: number;
}
export const monitor = (json: MonitorJson): any =>
  http.httpGet({
    url: httpApi.homes.monitor,
    json,
  });

// 搜狗PC端注册上报
interface SougouMonitorJson {
  clickTime: number;
  clickId: string;
  accountId: string;
  callback: string;
}
export const sougouMonitor = (json: SougouMonitorJson): any =>
  http.httpPost({
    url: httpApi.homes.sougouMonitor,
    json,
  });

// 买量游戏根据标签分类展示
interface GetPopularizeGamesData {
  gameType: number;
  size: number;
}

// 版本与标签接口
export const getPopularizeGames = (json: GetPopularizeGamesData): any =>
  http.httpGet({
    url: httpApi.homes.getPopularizeGames,
    json,
  });
